export const FILE_IMPORT_ACTIONS = {
  IMPORT_STARTED: 'IMPORT_STARTED',
  IMPORT_LOADING: ' IMPORT_LOADING',
  IMPORT_CLEAR: 'IMPORT_CLEAR',
  CLOSE_NOTIFICATION: 'CLOSE_NOTIFICATION'
};

export interface IFileImportAction {
  type: string,
  payload?: {
    importSwaggerLoading?: boolean,
    uploadFileName?: string,
    fileNotificationStatus?: boolean,
    fileUploadStatus?: boolean
  }
}

export interface IImportFileState {
  importSwaggerLoading: boolean,
  uploadFileName: string,
  fileNotificationStatus: boolean,
  fileUploadStatus: boolean
}

export const initialImportState: IImportFileState = {
  importSwaggerLoading: false,
  uploadFileName: '',
  fileNotificationStatus: false,
  fileUploadStatus: false
};

/**
 * Reducer function to manage file import status
 * @param state import state
 * @param action import actions
 * @returns updated state
 */
export const constructFileImportReducer = (state: IImportFileState, action: IFileImportAction) => {
  switch (action.type) {
    case FILE_IMPORT_ACTIONS.IMPORT_STARTED: {
      return {
        ...state,
        importSwaggerLoading: action.payload?.importSwaggerLoading ?? false,
        fileNotificationStatus: action.payload?.fileNotificationStatus ?? false,
        fileUploadStatus: action.payload?.fileUploadStatus ?? false,
        uploadFileName: action.payload?.uploadFileName ?? ''
      };
    }
    case FILE_IMPORT_ACTIONS.IMPORT_LOADING: {
      return {
        ...state,
        importSwaggerLoading: action.payload?.importSwaggerLoading ?? false
      };
    }
    case FILE_IMPORT_ACTIONS.CLOSE_NOTIFICATION: {
      return {
        ...state,
        fileNotificationStatus: false
      };
    }
    case FILE_IMPORT_ACTIONS.IMPORT_CLEAR: {
      return {
        ...state,
        importSwaggerLoading: false,
        fileNotificationStatus: false,
        fileUploadStatus: false,
        uploadFileName: ''
      };
    }
    default: return state;
  }
};
